import { createAction, props } from '@ngrx/store';
import { ProjectApiError, ProjectGenericError } from './project.errors';
import { ProjectQuery, ProjectSortOrderType } from './project.reducer';
import { Project } from './models/project.model';
import { ProjectSettings } from './models/project-settings.model';
import { ProjectSummary } from './models/project-summary.model';
import { ConfigParameters, ConfigSettings } from '../config/models/config-settings.model';

export const SetCurrentProject = createAction(
  '[Project] Set Current Project',
  props<{ project: Project }>(),
);

export const LoadProject = createAction('[Project] Load Project', props<{ projectId: number }>());

export const SetLoadProjectError = createAction(
  '[Project] Set Load Project API Error',
  props<{ error: ProjectApiError }>(),
);

export const SetProjectsApiError = createAction(
  '[Project] Set Projects API Error',
  props<{ error: ProjectApiError }>(),
);

export const RemoveProjectsApiError = createAction('[Project] Remove Projects API Error');

export const LazyLoadProjects = createAction('[Project] Lazy load Projects');

export const CreateNewProject = createAction(
  '[Project] Create New Project',
  props<{
    deploy: boolean;
    projectSettings: ProjectSettings;
    configSettings: ConfigSettings;
    configParameters?: ConfigParameters;
    templateId?: number;
  }>(),
);

export const ProjectCreated = createAction(
  '[Project] Project Created',
  props<{
    project: Project;
    redirect: string;
    deploy: boolean;
    configSettings?: ConfigSettings;
    configParameters?: ConfigParameters;
    templateId?: number;
  }>(),
);

export const UpdateProject = createAction(
  '[Project] Update Project',
  props<{
    deploy: boolean;
    projectSettings: ProjectSettings;
    configSettings?: ConfigSettings;
    configParameters?: ConfigParameters;
  }>(),
);

export const ProjectUpdated = createAction(
  '[Project] Project Updated',
  props<{
    projectSettings: ProjectSettings;
    redirect: string;
    deploy: boolean;
    configSettings?: ConfigSettings;
    configParameters?: ConfigParameters;
  }>(),
);

export const DeleteProject = createAction(
  '[Project] Delete Project',
  props<{ projectId: number }>(),
);

export const DuplicateProject = createAction(
  '[Project] Duplicate Project',
  props<{
    existingProject: ProjectSettings;
    projectName: string;
  }>(),
);

export const SetProjectSortOrder = createAction(
  '[Project] Set Sort Order',
  props<{
    sortOrder: ProjectSortOrderType;
  }>(),
);

export const ShowDeployProjectConfirm = createAction(
  '[Project] Show Deploy Project Confirm',
  props<{ project: ProjectSummary }>(),
);

export const ShowDeleteProjectConfirm = createAction(
  '[Project] Show Delete Project Confirm',
  props<{
    project: ProjectSummary;
  }>(),
);

export const SetProjectConfirmCancelled = createAction(
  '[Project] User Cancelled Confirmation Dialog',
);

export const ShowDuplicateProjectDialog = createAction(
  '[Project] Show Duplicate Project Dialog',
  props<{
    project: ProjectSummary;
  }>(),
);

export const ClosedDuplicateProjectDialog = createAction(
  '[Project] Closed Duplicate Project Dialog',
);

export const ClosedCreateProjectDialog = createAction('[Project] Closed Create Project Dialog');

export const SetProjectGenericError = createAction(
  '[Project] Project Error',
  props<{
    error: ProjectGenericError;
  }>(),
);

export const LoadProjectSummaries = createAction(
  '[Project] Load Project Summaries',
  props<{
    query: ProjectQuery;
  }>(),
);

export const LoadProjectSummary = createAction(
  '[Project] Load Project Summary',
  props<{
    projectId: number;
  }>(),
);

export const ReceiveProjectSummaries = createAction(
  '[Project] Receive Project Summaries',
  props<{
    payload: ProjectSummary[];
  }>(),
);

export const ReceiveProjectSummary = createAction(
  '[Project] Receive Project Summary',
  props<{
    payload: ProjectSummary;
  }>(),
);
